import { NavController, NavParams, Events, Platform } from 'ionic-angular';
import { Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl, AbstractControl } from '@angular/forms';

import { DataService } from '../../services/data';
import { AlertMessager } from '../../lib/alertMessager';
import { LoadingController } from 'ionic-angular';
import { AuthenticateService } from '../../services/authenticateService';
import { LocalStorageService } from '../../services/local-storage';
import { EventNames } from '../../lib/eventNames';
import { AccountHelper } from '../../lib/accountHelper';
import { RodeosPage } from '../rodeo/rodeos';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'page-reset-password',
    templateUrl: 'reset-password.html'
})
export class ResetPasswordPage {
    password: string = '';
    confirmPassword: string = '';

    resetForm: FormGroup;
    validationMessages: any[];

    passwordType: string = 'password';
    passwordIconType: string = 'eye';

    emailAddress: string;
    resetCode: string;
    resettingPassword: boolean;

    constructor(public nav: NavController, private data: DataService, private alertMessager: AlertMessager, 
                private localStorage: LocalStorageService, private loadingControl: LoadingController, private formBuilder: FormBuilder, navParams: NavParams, 
                private authenticateService: AuthenticateService, private events: Events, private userService: UserService, private platform: Platform) {
        this.emailAddress = navParams.get('emailAddress');
        this.resetCode = navParams.get('resetCode');

        this.resetForm = this.formBuilder.group({
            password: new FormControl('password',  Validators.required),
            confirmPassword: new FormControl('confirm',  this.checkPasswords),
        });
            
        this.validationMessages = [
            { name: 'password', type: 'required', message: 'Password is required.' },
            { name: 'confirmPassword', type: 'checkPasswords', message: 'Passwords do not match.' },
        ];
    }

    checkPasswords(control: AbstractControl) {
        if (!control || !control.parent) {
            return null;
        }

        const password = control.parent.get('password');
        const confirmPass = control.parent.get('confirmPassword');

        if (password == null || confirmPass == null) {
            return null;
        }

        return password.value === confirmPass.value && confirmPass.value != null && confirmPass.value != '' ? null : { checkPasswords: true};
    }

    showHide() {
        if (this.passwordType == 'text') {
            this.passwordType = 'password';
            this.passwordIconType = 'eye';
        }
        else {
            this.passwordType = 'text';
            this.passwordIconType = 'eye-off';
        }
    }

	resetPassword() {
        if (this.resettingPassword)
            return;

        this.resettingPassword = true;
        let loading = this.loadingControl.create({
            content: 'Resetting password...',
        });

        loading.present();
		this.data.setNewPassword(this.emailAddress, this.resetCode, this.password)
		.then(data => {
            loading.dismiss();
            this.resettingPassword = false;

            if ((data as any).errorMessage !== undefined) {
                this.alertMessager.showError("Password Reset Error", (data as any).errorMessage);
            } else {				
                loading = this.loadingControl.create({
                    content: 'Logging you in...',
                });
        
                loading.present();
                this.authenticateService.authenticate(this.emailAddress, this.password)
                .then(data => {
                    loading.dismiss();

                    if ((data as any).errorMessage !== undefined) {
                        this.alertMessager.showError("Login Error", (data as any).errorMessage);
                    } else  if (data['id'] === 0) {
                        this.alertMessager.showError('Login Error', 'The email or password provided is incorrect.');
                    }
                    else {				
                        this.localStorage.updateEntity('authtokens', data)
                        .then(data => {
                            this.nav.pop();
                            
                            this.events.publish(EventNames.userLoggedIn);
                            AccountHelper.instance().loadToken(data);
                            this.userService.getUser(data.id);

                            this.nav.setRoot(RodeosPage);
                        });
                    }
                }, error => {
                    loading.dismiss();
                    this.alertMessager.showError('Login Error', error);
                });
			}
		}, error => {
            loading.dismiss();
            this.resettingPassword = false;
            this.alertMessager.showError('Password Reset Error', error);
        });
	}
}


// WEBPACK FOOTER //
// ./src/pages/login/reset-password.ts